
import React, {useEffect} from 'react';
import {useKrispNoiseFilter} from '@livekit/components-react/krisp';

export const KrispEnabler = () => {
	const krisp = useKrispNoiseFilter();
	useEffect(() => {
		krisp.setNoiseFilterEnabled(true);
	}, []);
	return <></>;
};
